"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ChevronRight, DollarSign, Crown, User, Gift, MapPin, LogOut } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuthWithLocationSync } from "@/hooks/use-auth-with-location-sync";

const sections = [
  { label: "Balance Calii", href: "/cuenta/balance", icon: DollarSign },
  { label: "Membresía Calii+", href: "/cuenta/membresia", icon: Crown },
  { label: "Perfil", href: "/cuenta/perfil", icon: User },
  { label: "Cupones", href: "/cuenta/cupones", icon: Gift },
  { label: "Direcciones de entrega", href: "/cuenta/direcciones", icon: MapPin },
];

// Inspired by https://x.com/settings/about
export default function CuentaSidebar() {
  const pathname = usePathname();
  const { logout } = useAuthWithLocationSync();
  const isOnSubRoute = pathname !== "/cuenta";

  return (
    <nav
      className={cn(
        "w-full md:w-72 md:border-r md:block shrink-0",
        isOnSubRoute && "hidden md:block"
      )}
    >
      <ul className="divide-y">
        <li><h1 className="text-2xl font-bold px-4 py-6">Cuenta</h1></li>
        {sections.map((section) => {
          const isActive = pathname.startsWith(section.href);
          return (
            <li key={section.href}>
              <Link
                href={section.href}
                className={cn(
                  "flex items-center gap-3 px-4 py-4 text-sm transition-colors hover:bg-muted/50",
                  isActive && "bg-muted/50 font-medium"
                )}
              >
                <section.icon className="h-5 w-5 text-muted-foreground shrink-0" />
                <span className="flex-1">{section.label}</span>
                <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
              </Link>
            </li>
          );
        })}
        <li><div /></li>
        <li className="md:hidden">
          <button
            onClick={logout}
            className="flex items-center gap-3 px-4 py-4 text-sm w-full transition-colors hover:bg-muted/50 text-red-600"
          >
            <LogOut className="h-5 w-5 shrink-0" />
            <span className="flex-1 text-left">Cerrar sesión</span>
          </button>
        </li>
      </ul>
    </nav>
  );
}
